import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { D1StaticDatumsEdit } from "./edit";
import { D1StaticDataNew } from "./new";
import { D1StaticDatumsTable } from "./table";
export default function D1StaticDatums() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Actifs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<D1StaticDatumsEdit />} />
      <Route index element={<D1StaticDatumsTable />} />
      <Route path="/new" element={<D1StaticDataNew />} />
    </Routes>
  );
}
